import { useMutation } from "@tanstack/react-query";
import { AddProgramme } from "../services/programmeService";


export const useCreateProgramme = () => {
    const { mutate: createProgramme } = useMutation({
      mutationFn: (programme) => AddProgramme(programme),
    });

    return createProgramme;
}
